import { get } from 'services/request';

export type IActiveInflectTemplateSelect = {
  id: number;
  name: string;
  wordClass: number;
  effectiveWordClass: number;
  effectiveWordClassName: string;
};

export default class ActiveInflectTemplateSelectModel {
  async get(courseId: number) {
    return await get<IActiveInflectTemplateSelect[]>(`courses/${courseId}/active-inflect-templates/select`);
  }
}
